import React from "react";
import Loader from 'react-loader-spinner'
import { translate } from "../../utils/useful";


class AddPermissionHome extends React.Component {
  state = {
    isLoadingRemove: false,
    id: null,
    index: null,
    image:''
  }

  // images=["001-man.svg",'011-woman.svg','012-woman.svg','019-man.svg','022-man.svg','025-man.svg','027-woman.svg','033-woman.svg','035-man.svg','038-man.svg','042-man.svg','043-woman.svg','049-woman.svg','050-woman.svg']

  componentDidMount(){
    // this.changeImage()
    //  this.interval = setInterval(() => {
    //   this.changeImage()
    // }, 1500);
  }


  componentWillUnmount(){
    clearInterval(this.interval)
  }

  changeImage=()=>{
    let number = Math.floor(Math.random()*this.images.length-1)
    if(this.images[number]){
    let image = this.images[number]
    this.setState({image})
    }
  }

  // hideModal = () => {
  //   this.removeModal.hideModal()
  // }


  render() {
    return (
      <div className="" style={{}}>
        <div className="flexcc flex-column py-2  px-4" style={{borderRadius:'8px 8px 0px 0px', background:'linear-gradient(to  top,rgb(0, 122, 255), rgb(40, 102, 245))'}}>
          {/* <img src={'/images/password.svg'} alt="" width="40px" /> */}
          <p className="mt-1 text-big text-bold white">{translate("Add Permission")}</p>
        </div>


        <p className="mt-4 text-small text-center ">{translate("You want to give new access to users or groups?")}</p>



        {!this.props.isLoading && (
          <div className="flexcc mt-3 px-3 pb-3">
            <button onClick={()=>this.props.onDone('users')} className="m-1 p-3 px-4   w-100"   style={{boxShadow:'inset 0 0 10px #eee', background:'linear-gradient(to left bottom,#f2f6f8,#eee)',borderRadius:8}}>
              <img className="" src={'/images/avatar.png'} alt="" height="50px" />
              <p className="text-normal  text-bold mt-2 p-0  text-uppercase" style={{  lineHeight: 1, textAlign: 'center', }}>{translate('users')}</p>
              <p className="text-smaller   mt-1 p-0" style={{  lineHeight: 1, textAlign: 'center', }}>{translate('new access for one or more users')}</p>

            </button>
            <button onClick={()=>this.props.onDone('groups')} className="m-1 p-3 px-4    w-100"  style={{ boxShadow:'inset 0 0 10px #eee',background:'linear-gradient(to left bottom,#f2f6f8,#eee)',borderRadius:8 }}>
              <img className="" src={'/images/networking.png'} alt="" height="50px" />
              <p className="text-normal  text-bold mt-2 p-0 text-uppercase" style={{  lineHeight: 1, textAlign: 'center', }}>{translate("groups")}</p>
              <p className="text-smaller   mt-1 p-0" style={{  lineHeight: 1, textAlign: 'center', }}>{translate('new access for one or more groups')}</p>

            </button>
          </div>
        )}
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          {this.props.isLoading && (
            <Loader
              type="Puff"
              color="rgba(0,122,255,1)"
              height="40"
              width="40"
            />)}
        </div>
      </div>

    );
  }
}



export default AddPermissionHome;
